import React from 'react';
import { useParams } from 'react-router-dom';
import Breadcrumbs from '~/components/Breadcrumbs/Breadcrumbs';
import Spacer from '~/components/Spacer/Spacer';
import CobuConstants from '~/helpers/cobuConstants';
import style from './UniversalButton.module.css';
import Spinner from '~/components/Spinner/Spinner';
import { getCreateUniversalButtonFormConfig } from '~/helpers/formHelpers';
import CreateUniversalButtonForm from '~/components/CreateUniversalButtonForm/CreateUniversalButtonForm';
import useUniversalButton from '~/hooks/universalButtons/useUniversalButton';

const UniversalButton = () => {
  /* Params */
  const { buttonId } = useParams<{
    buildingId: string;
    buttonId: string;
  }>();

  /* Data logics */
  const {
    universalButtonState: { loading, loadingString, universalButtonData },
    updateUniversalButton
  } = useUniversalButton(buttonId);

  /* UI Components */

  if (loading)
    return (
      <div className={style.loadingContainer}>
        <Spinner />
        <h3 className={style.heading}>{loadingString}</h3>
      </div>
    );

  if (!universalButtonData)
    return (
      <div className={style.loadingContainer}>
        <h1 className={style.heading}>{'An error occurred.'}</h1>
        <h4 className={style.heading}>
          {'Unable to fetch universal button. Please try again later.'}
        </h4>
      </div>
    );

  return (
    <div className='content-container float-spinner-parent'>
      {loading && <Spinner float />}
      <Breadcrumbs indexesToHide={[2]} />
      <Spacer height={10} />
      <h1>
        {universalButtonData.buildingName} -{' '}
        {CobuConstants.activeUniversalButtons.universalButton}
      </h1>
      <Spacer height={10} />
      <CreateUniversalButtonForm
        cancel={() => {}}
        createUniversalButton={(button) => {}}
        updateUniversalButton={(button) => updateUniversalButton(button)}
        formConfig={getCreateUniversalButtonFormConfig()}
        defaultData={universalButtonData}
      />
    </div>
  );
};

export default UniversalButton;
